import Bone from "../../../../Components/Skeleton/Bone"

import styles from "./skeleton.module.less"

// DashboardCards whose figures are still loading: title and icon as they are, and a bar at the
// value's 34px line in the `cta` slot, which DashboardCard renders in place of the value row.
export const withValueSkeleton = (cards) =>
  cards.map((card) => ({
    ...card,
    cta: (
      <span className={styles.cardValue}>
        <Bone width={96} height={24} />
      </span>
    )
  }))
